import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ManagedPayrollPeopleCompliance = () => {
  const serviceData = {
    title: "Managed Payroll & People Compliance",
    heading: "Managed Payroll & People Compliance",
    image: subTopicImages["Managed Payroll & People Compliance"],
    intro:
      "Payroll must be timely, confidential and fully compliant with applicable laws.",
    description: [
      "We manage your payroll function end-to-end with accuracy and control.",
    ],
    services: [
      {
        title: "Payroll & People Compliance Services",
        text: "Our scope includes:",
        list: [
          "monthly payroll processing",
          "tax and statutory deductions",
          "payroll compliance filings",
          "leave and benefit computation",
          "payslip & MIS issuance",
          "employee data maintenance",
        ],
        extraInfo:
          "We also ensure compliance with applicable labour and taxation laws, reducing risk and administrative burden.",
      },
    ],
    benefitsIntro: "",
    benefits: [
      "This allows management to remain confident that employees are paid correctly and statutory compliances are fully taken care of.",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default ManagedPayrollPeopleCompliance;
